import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { Loader } from '@components';
import { sitesQuery, siteMutation } from '@queries';
import { ButtonSpinnerDarkIcon, MonitorIcon, MoreHorizontalIcon } from '@svgs';

const Site = ({ site }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  // save user
  const mutation = useMutation(
    siteMutation(site.id, {
      onSuccess: (data) => {
        // invalidate user lists and detail
        queryClient.invalidateQueries({
          queryKey: ['sites', 'detail', site.id],
        });
        queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
        navigate(`/dashboard/sites/${site.id}/custom_fields`);
      },
    }),
  );

  return (
    <div className="sb-row-item">
      <div>
        <p>Website</p>
      </div>
      <div>
        <p>
          {site.deleted && <>{site.display_url}</>}
          {!site.deleted && (
            <Link
              to={`/dashboard/sites/${site.id}/custom_fields`}
              title={site.display_url}
            >
              {site.display_url}
            </Link>
          )}
        </p>
      </div>
      <div>{site.title}</div>
      <div>{!site.deleted ? 'Active website' : 'Disabled website'}</div>
      {site.deleted && (
        <div className="sb-options">
          {mutation.isPending && <ButtonSpinnerDarkIcon />}
          {!mutation.isPending && (
            <>
              <button
                className="sb-page-options-menu-trigger sb-options-trigger"
                onClick={() => setShowDropdownMenu(!showDropdownMenu)}
              >
                <MoreHorizontalIcon />
              </button>
              <div
                ref={dropdownMenu}
                className={
                  'sb-options-menu ' +
                  (showDropdownMenu ? 'sb-show' : 'sb-hide')
                }
              >
                <div className="sb-options-menu-content">
                  <button
                    type="button"
                    className="sb-options-item"
                    onClick={() => mutation.mutate({ deleted: false })}
                  >
                    <MonitorIcon />
                    {t('Re-activate site')}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export const SearchSites = ({ searchDisabled = false, searchTerm }) => {
  // Fetch sites
  const {
    data: sitesData,
    isPending: sitesIsPending,
    isError,
  } = useQuery(
    sitesQuery({
      q: searchTerm,
      deleted: searchDisabled ? 1 : 0,
      limit: 100,
      order_by: 'base_directory',
      type: 'default',
    }),
  );

  return (
    <>
      {sitesIsPending && <Loader className="sb-loader sb-loader-block" />}
      {!sitesIsPending && sitesData.objects.length === 0 && (
        <p>No websites found</p>
      )}
      {!sitesIsPending && sitesData.objects.length > 0 && (
        <>
          <div className="sb-content-view-row">
            {sitesData.objects.map((site) => {
              return <Site key={site.id} site={site} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
